import { useRef, useEffect, useState } from 'react';
import NavLinks from 'components/NavLinks';
import styles from './header.module.scss';

const NAME = 'brian_hampson';

interface HeaderProps {
  onNameComplete?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onNameComplete }) => {
  const titleRef = useRef<HTMLDivElement>(null);
  const [displayName, setDisplayName] = useState('');
  const [nameDone, setNameDone] = useState(false);

  useEffect(() => {
    const timeouts: ReturnType<typeof setTimeout>[] = [];
    const intervals: ReturnType<typeof setInterval>[] = [];

    const startDelay = setTimeout(() => {
      let i = 0;
      const t = setInterval(() => {
        i++;
        setDisplayName(NAME.slice(0, i));
        if (i >= NAME.length) {
          clearInterval(t);
          setNameDone(true);
          // Pause after name completes — let it register before the rest fires
          const beatPause = setTimeout(() => {
            onNameComplete?.();
          }, 700);
          timeouts.push(beatPause);
        }
      }, 90);
      intervals.push(t);
    }, 100);

    timeouts.push(startDelay);

    return () => {
      timeouts.forEach(clearTimeout);
      intervals.forEach(clearInterval);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <header id="top-of-page" className={styles.headerRoot}>
      <div className={styles.areaLeft}>
        <div className={`${styles.titleParent} titleParent`} ref={titleRef}>
          <span className={styles.titleText}>{displayName}</span>
          {!nameDone && displayName.length > 0 && (
            <span className={styles.cursor}>▌</span>
          )}
        </div>
      </div>
      <div className={styles.areaMiddle}></div>
      <div className={styles.areaRight}>
        <NavLinks />
      </div>
    </header>
  );
};

export default Header;
